import React from 'react';
import PropTypes from 'prop-types';

export default class MapboxControl extends React.PureComponent {
    
    render() {
        if (!this.props.render) {
            return null;
        }

        let controlIconClassName = "mapbox-control-icon";
        let pendingOverlayElement;

        if (this.props.pending) {
            controlIconClassName = controlIconClassName + " disabled";
            pendingOverlayElement = (<div className="icon-spinner-overlay"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>);
        }

        let imgElement;

        if (this.props.iconName && this.props.onClick instanceof Function) {

            var materialClassName = "material-icons " + controlIconClassName;

            if(this.props.disabled) {
                imgElement = (<i className={materialClassName}>{this.props.iconName}</i>);
            } 
            else {
                imgElement = (<i className={materialClassName} onClick={this.props.onClick}>{this.props.iconName}</i>);
            }
        }
        else if (this.props.disabled) {
            imgElement = (<img className={controlIconClassName} alt="disabled" src={this.props.iconSrc}/>);
        }
        else if (this.props.onClick instanceof Function) {
            imgElement = (<img className={controlIconClassName} alt="go to google maps" src={this.props.iconSrc} onClick={this.props.onClick}/>);
        } else { // it is a string, treat it as a download link URL
            imgElement = (<a download href={this.props.onClick}><img className={controlIconClassName} alt="go to google maps" src={this.props.iconSrc} /></a>);
        }
        
        return (
            <button
                id={this.props.id}
                disabled={!!this.props.disabled}
                title={(typeof this.props.disabled === "string") ? this.props.disabled : undefined}
                className="event-media-control">
                {imgElement}
                <div className="label">
                    {this.props.children}
                </div>
                {pendingOverlayElement}
            </button>
        )
    }
}

MapboxControl.propTypes = {
    id: PropTypes.string,
    iconName: PropTypes.string,
    render: PropTypes.bool.isRequired, /* false will return null */
    pending: PropTypes.bool, /* true will display a spinner over top semi-transparent iconSrc */
    disabled: PropTypes.oneOfType([
        PropTypes.string, /* provide a disabled tooltip string to disable the button */
        PropTypes.bool
    ]),
    onClick: PropTypes.oneOfType([
        PropTypes.func,  // callback
        PropTypes.string // or link url
    ]),
};
